import React from 'react';
import { TextField } from '@mui/material';
import { LocalizationProvider, DatePicker } from '@mui/x-date-pickers';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import dayjs from 'dayjs';

const CustomDatePicker = ({
  value,
  onChange,
  placeholder = 'MM-DD-YYYY',
  maxDate = undefined,
  minDate = undefined,
  name = 'date',
  className = '',
  disabled = false,
  showIcon = false
}) => {
  const parsedValue = value ? dayjs(value) : null;

  return (
    <LocalizationProvider dateAdapter={AdapterDayjs}>
      <DatePicker
        value={parsedValue}
        onChange={newValue => {
          if (newValue?.isValid()) {
            onChange(newValue.toISOString()); // Save in ISO format
          } else {
            onChange(null);
          }
        }}
        minDate={minDate ? dayjs(minDate) : undefined}
        maxDate={maxDate ? dayjs(maxDate) : undefined}
        disabled={disabled}
        renderInput={params => (
          <TextField
            {...params}
            fullWidth
            name={name}
            placeholder={placeholder}
            className={className}
          />
        )}
      />
    </LocalizationProvider>
  );
};

export default CustomDatePicker;
